const secret_key = process.env.VUE_APP_SECRET_KEY;

function generateSignatureOtherService(obj) {
  let md5 = require("md5");
  let md5_data = ``;
  let data_sort = Object.keys(obj)
    .sort()
    .reduce(function(result, key) {
      result[key] = obj[key];
      return result;
    }, {});
  for (let u of Object.keys(data_sort)) {
    md5_data += `${data_sort[u]}`;
  }
  let key_select = md5(`${secret_key}${md5_data}`);
  //   console.log("key_hash", key_select);
  return key_select;
}

export { generateSignatureOtherService };
